import {v4 as uuidv4} from "uuid";
import {faker}  from "@faker-js/faker";
import { getDefaultDateTime } from "../../utils/task";
import { getAllInstanceIds } from "../helpers/instance-helper";
import moment from "moment";
import { TERRAFORM_APPLY } from "../../utils/app-constants.json";

var startdatetime = moment();
startdatetime = moment.utc(startdatetime.subtract(3, "days"));

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];
var status = ["SUCCESS"];
var types = [
  {
    name: "Analytics and Data Insights Accelerator", // s3
    action: "start",
    category: TERRAFORM_APPLY,
  },
  { name: "Start All Instances", action: "start", category: "START" },
  {
    name: "Stop Dev Instances",
    action: "stop",
    category: "STOP",
    status: "FAILED",
  },
  // {
  //   name: "Backup Instances",
  //   action: "stop",
  //   category: "STOP",
  //   scope: "14a6531d-9101-4c87-983b-146a89eabc5b"
  // },
  // {
  //   name: "Restore Instances",
  //   action: "stop",
  //   category: "STOP",
  //   scope: "14a6531d-9101-4c87-983b-146a89eabc5b"
  // },
  {
    name: "Backup Instances",
    action: "stop",
    category: "STOP",
  },
  {
    name: "Restore Instances",
    action: "stop",
    category: "STOP",
  },
  { name: "Stop Dev Instances", action: "stop", category: "STOP" },
  {
    name: "Patch All Instances",
    action: "installPatch",
    category: "PATCH-INSTALL",
  },
  {
    name: "Patch Testing Instances",
    action: "installPatch",
    category: "PATCH-INSTALL",
  },
  { name: "Scan All Instances", action: "scanPatch", category: "PATCH-SCAN" },
  {
    name: "Scan Testing Instances",
    action: "scanPatch",
    category: "PATCH-SCAN",
  },
  {
    name: "Desired State Testing Instances",
    action: "executeDss",
    category: "DESIRED-SERVER-STATE",
  },
];

export const createJob = async (data, startTime) => {
  let randomInstance = [];
  const allInstanceIds = await getAllInstanceIds();
  for (let i = 0; i < faker.number.int(10); i++) {
    let instance = faker.helpers.arrayElement(allInstanceIds);
    // checking if instance already exists in the array or not
    randomInstance.indexOf(instance) === -1 && randomInstance.push(instance);
  }
  var job = {
    Category: data.category,
    ActionData: {
      Action: "terminate",
      Accounts: [
        {
          Regions: [
            {
              InstanceId: randomInstance,
              RegionCode: faker.helpers.arrayElement(regionCodes),
            },
          ],
          AccountNumber: "846823036883",
        },
      ],
      ActionMapper: {
        Type: data.category === TERRAFORM_APPLY ? data.category : "DAY2",
      },
    },
    Title: data.name,
    StatusUpdatedOn: startdatetime,
    JobId: uuidv4(),
    Offset: "1555063100.0",
    CreatedBy: 15.0,
    ExecutionStatus: data.status
      ? data.status
      : faker.helpers.arrayElement(status),
    CreatedAt: startdatetime,
  };

  if (data && data.scope) {
    job.ActionData = {
      ScopeId: "14a6531d-9101-4c87-983b-146a89eabc5b",
      Action: "terminate",
      Accounts: [
        {
          Regions: [
            {
              InstanceId: randomInstance,
              RegionCode: "us-east-2",
            },
          ],
          AccountNumber: "846823036883",
        },
      ],
    };
  }

  return job;
};

export const allJobs = async () => {
  let jobs = [];

  for (const type of types) {
    startdatetime = moment.utc(
      startdatetime
        .subtract(faker.helpers.arrayElement([1, 2]), "days")
        .subtract(faker.helpers.arrayElement([10, 20, 25, 30]), "minutes")
        .subtract(faker.helpers.arrayElement([15]), "seconds")
    );
    var job = await createJob(type, startdatetime);
    jobs.push(job);
  }

  return jobs;
};

export const addJob = async (id, jobs) => {
  var data = {
    name: id,
    action: "data-refresh",
    category: "DATA_REFRESH",
  };
  var job = await createJob(data);
  job.Title = id;
  job.ExecutionStatus = "RUNNING";
  jobs.unshift(job);
  return jobs;
};

export const addInstanceJob = (data, jobs, jobId) => {
  var newJob = {
    Category:
      data.Action === "executeDss"
        ? "DESIRED-SERVER-STATE"
        : data.Action && data.Action.toUpperCase(),
    ActionData: {
      Action: data.Action,
      Accounts: [
        {
          Regions: [
            {
              InstanceId: data.ResourceIds,
              RegionCode: "us-east-1",
            },
          ],
          AccountNumber: "846823036883",
        },
      ],
    },
    Title:
      data.Job && data.Job.Name
        ? data.Job.Name
        : data.Action &&
          data.Action.length > 0 &&
          data.Action[0].toUpperCase() + data.Action.slice(1) + " Instance",
    StatusUpdatedOn: getDefaultDateTime(),
    JobId: jobId,
    Offset: "1555063100.0",
    CreatedBy: 15,
    ExecutionStatus: "SUCCESS",
    CreatedAt: getDefaultDateTime(),
  };
  jobs.unshift(newJob);
  return jobs;
};
